<template>
  <div style="padding: 10px">
    请勿短时间内多次支付，请稍等1分钟后再试
    <a @click="$router.back" style="color: blue; margin-left: 10px">返回</a>
  </div>
</template>
